import React, { useEffect, useState, Component } from 'react';
import { motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    label: 'Inicio',
    href: '#inicio'
  }, {
    label: 'Nosotros',
    href: '#nosotros'
  }, {
    label: 'Productos',
    href: '#productos'
  }, {
    label: 'Mesas Dulces',
    href: '#mesas-dulces'
  }, {
    label: 'Catering',
    href: '#catering'
  }, {
    label: 'Galería',
    href: '#galeria'
  }, {
    label: 'Contacto',
    href: '#contacto'
  }];
  const handleWhatsApp = () => {
    const message = encodeURIComponent('Hola! Quiero consultar sobre los productos y servicios de La Victoria II.');
    window.open(`https://wa.me/5492665013601?text=${message}`, '_blank');
  };
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`} data-id="element-125">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-126">
        <div className="flex items-center justify-between h-20" data-id="element-127">
          <a href="#inicio" className="flex flex-col items-center justify-center -mt-1" data-id="element-128">
            <img src="https://cdn.magicpatterns.com/uploads/t9YYCR56qhXKr15r8GLDg4/Black_and_Brown_Catering_Logo_(1).png" alt="La Victoria II Logo" className="h-10 w-10 object-contain" data-id="element-129" />
            <span className={`font-serif font-bold text-sm leading-none mt-1 ${isScrolled ? 'text-secondary-brown' : 'text-white'}`} data-id="element-130">
              2
            </span>
          </a>

          <div className="hidden md:flex items-center space-x-8" data-id="element-131">
            {navLinks.map(link => <a key={link.href} href={link.href} className={`text-sm font-medium transition-colors hover:text-primary-yellow ${isScrolled ? 'text-secondary-brown' : 'text-white'}`} data-id="element-132">
                {link.label}
              </a>)}
            <button onClick={handleWhatsApp} className="bg-primary-yellow text-secondary-brown px-6 py-2 rounded-full font-medium hover:bg-primary-gold transition-colors" data-id="element-133">
              WhatsApp
            </button>
          </div>

          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className={`md:hidden ${isScrolled ? 'text-secondary-brown' : 'text-white'}`} aria-label="Toggle menu" data-id="element-134">
            {isMobileMenuOpen ? <XIcon size={24} data-id="element-135" /> : <MenuIcon size={24} data-id="element-136" />}
          </button>
        </div>
      </div>

      {isMobileMenuOpen && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} exit={{
      opacity: 0,
      height: 0
    }} className="md:hidden bg-white border-t border-secondary-cream" data-id="element-137">
          <div className="px-4 py-6 space-y-4" data-id="element-138">
            {navLinks.map(link => <a key={link.href} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block text-secondary-brown hover:text-primary-yellow transition-colors" data-id="element-139">
                {link.label}
              </a>)}
            <button onClick={handleWhatsApp} className="w-full bg-primary-yellow text-secondary-brown px-6 py-3 rounded-full font-medium hover:bg-primary-gold transition-colors" data-id="element-140">
              WhatsApp
            </button>
          </div>
        </motion.div>}
    </motion.nav>;
}